import type { Event } from '@patsnap/tahiti-core';
import type { Figure, Annotation } from './impls/specification';

export const FigureService = Symbol.for('FigureService');

/**
 * 图形服务接口，用于管理说明书中的图形及其相关操作
 */
export interface FigureService {
    /**
     * 当前图形索引变化事件
     */
    readonly onCurrentIndexChange: Event<number>;

    /**
     * 图形渲染就绪事件
     */
    readonly onFigureRenderReady: Event<void>;

    /**
     * 图形捕获事件
     */
    readonly onCaptureFigure: Event<void>;

    /**
     * 设置当前图形索引
     * @param index 要设置的索引
     */
    setCurrentIndex(index: number): void;

    /**
     * 获取当前图形索引
     */
    getCurrentIndex(): number;

    /**
     * 获取当前图形
     */
    getCurrentFigure(): Figure | null;

    /**
     * 获取当前图形编号
     */
    getCurrentFigureNumber(): number;

    /**
     * 检查是否有下一个图形
     */
    hasNextFigure(): boolean;

    /**
     * 检查是否有上一个图形
     */
    hasPreviousFigure(): boolean;

    /**
     * 移动到下一个图形
     */
    moveToNextFigure(): void;

    /**
     * 移动到上一个图形
     */
    moveToPreviousFigure(): void;

    /**
     * 获取图形总数
     */
    getTotalFigures(): number;

    /**
     * 获取当前图形的所有标注
     */
    getCurrentFigureAnnotations(): Annotation[];

    /**
     * 根据ID查找标注
     * @param annotationId 标注ID
     */
    findAnnotationById(annotationId: string): Annotation | undefined;

    /**
     * 通知图形渲染就绪
     */
    notifyFigureRenderReady(): void;

    /**
     * 请求捕获所有图形
     */
    requestCaptureAll(): Promise<void>;

    /**
     * 批量添加图形
     * @param urls 图形URL和S3Key数组
     */
    addFigures(urls: Array<{ url: string; s3Key: string }>): void;
}
